import * as cx from 'classnames';
import * as React from 'react';
import * as Styles from './OrderSection.scss';

interface IOwnProps {
  borderBottom?: boolean;
  blockFor?: string;
  transparent?: boolean;
}

const OrderSection: React.SFC<IOwnProps> = ({ children, borderBottom = true, blockFor, transparent = true }) => {
  const sectionClassNames = cx({
    [Styles.section]: true,
    [Styles.borderBottom]: borderBottom,
    [Styles.transparent]: transparent,
  });

  return (
    <div className={sectionClassNames} data-block-for={blockFor}>
      <div className={Styles.content}>
        {children}
      </div>
    </div>
  );
};

export default OrderSection;
